import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { forwardRef } from 'react';
import Content from '../Content/index.js';
const Button = styled.button(({ theme, color, textStyle = 'uppercase' }) => ({
    textTransform: textStyle,
    color: color || theme.primaryAccentColor,
    transition: 'opacity 0.2s ease',
    background: 'none',
    position: 'relative',
    fontSize: '1.2rem',
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    '& > *': {
        color: color || theme.primaryAccentColor
    },
    '&:not([disabled]):hover': {
        opacity: 0.5
    }
}));
const TextButton = forwardRef(({ cy, loading, type = 'button', ariaLabel, color: customColor, ...props }, ref) => {
    const theme = useTheme();
    const { size = 'small', icon, disabled, children, iconPosition } = props;
    const color = typeof customColor === 'function' ? customColor(theme) : customColor;
    return (_jsx(Button, { ...props, type: type, ref: ref, "data-cy": cy, tabIndex: 0, color: color, "aria-label": ariaLabel, disabled: disabled || loading, "aria-disabled": disabled || loading, children: _jsx(Content, { size: size, icon: icon, color: color, iconPosition: iconPosition, children: children }) }));
});
export default TextButton;
//# sourceMappingURL=index.js.map